import React, { useEffect, useId } from 'react';
import styles from './Checkbox.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';

const Checkbox = ({
  label,
  ischecked,
  onChange,
  isDisabled,
  name = '',
  rounded = false,
  labelClassName,
  boxClassName,
}) => {
  const id = useId();
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  const handleCheckboxChange = (e) => {
    e.stopPropagation();
    if (onChange) {
      onChange(e.target.checked, e);
    }
  };
  return (
    <div
      className={`${styles.checkbox}  ${label ? styles['label'] : ''}${
        isDisabled ? styles.checkboxDisabled : ''
      }`}
    >
      <label
        htmlFor={id}
        className={`${labelClassName} ${styles['checkbox-label']}`}
      >
        <input
          id={id}
          type="checkbox"
          checked={ischecked}
          onChange={(e) => handleCheckboxChange(e)}
          className={styles['checkbox-input']}
          disabled={isDisabled}
          name={name}
        />
        <span
          className={`${styles['checkbox-square']} ${boxClassName}`}
          style={{
            backgroundColor: ischecked ? page_ButtonColor : '',
            borderColor: ischecked ? page_ButtonColor : 'grey',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: rounded ? '100px' : '',
          }}
        />
        <p className={styles.label}>{label}</p>
      </label>
    </div>
  );
};

export default Checkbox;
